export default function FoxyLiveArtists() {
  return null;
}
